import React from 'react';

export default function FloatingCall({ lang, t }) {
    return (
        <a
            href={`tel:${t.phone}`}
            className="fixed bottom-6 right-6 z-[100] flex items-center gap-3 bg-green-600 text-white px-6 py-4 rounded-full shadow-2xl hover:bg-green-700 hover:scale-105 transition-all duration-300 md:bottom-10 md:right-10"
            style={{ direction: 'ltr' }} // Keep icon and text aligned consistently
        >
            <div className="bg-white/20 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                    <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.4-5.1-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.3-1.1-.5-2.3-.5-3.5 0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1 0 9.4 7.6 17 17 17 .6 0 1-.4 1-1v-3.5c0-.6-.4-1-1-1zM19 12h2c0-4.8-3.9-8.7-8.7-8.7v2c3.7 0 6.7 3 6.7 6.7z"/>
                </svg>
            </div>
            <span className="font-black uppercase tracking-widest text-sm">
                {t.callNow}
            </span>
        </a>
    );
}